import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";
import IconCheckedGreen from "../icons/IconCheckedGreen";



export default function ButtonBudgeting({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgBase: '#F1F5F7',
          colorText: '#384146',
          colorBorder: '#F1F5F7',
        },
      }}
    >
      <Button {...props} icon={<IconCheckedGreen/>} style={{display: 'flex', alignItems: 'center'}}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
